<script>
    import WebChatSetUp from './webchat';

    export default {

        components: { WebChatSetUp },
    }
</script>

<template>
    <div class="row">
        <div class="col-md-3 col-lg-4">
            <div class="st-product-card">
                <div class="st-product-card-header">
                    <span class="icon-circle webchat">
                        <i class="el-icon-s-comment"/>
                    </span>
                </div>

                <div class="st-product-card-body">
                    <h6>Engage with your customer from your <b>web</b> pages.</h6>
                </div>

                <div class="st-product-card-body-x">
                    <p>Embed a emalify web chat in your website so your website visitors can interact with you in realtime.</p>
                </div>

                <div class="st-product-card-actions">
                    <web-chat-set-up/>
                    <el-button plain size="small" class="ml-2">More ..</el-button>
                </div>
            </div>
        </div>

        <div class="col-md-3 col-lg-4">
            <div class="st-product-card">
                <div class="st-product-card-header">
                    <span class="icon-circle mobile">
                        <i class="el-icon-s-comment"/>
                    </span>

                </div>

                <div class="st-product-card-body">
                    <h6>Engage with your customer from your <b>mobile</b> app.</h6>
                </div>

                <div class="st-product-card-body-x">
                    <p>Get the emalify chat sdk and embed in your mobile app so your app users can interact with you from the app.</p>
                </div>

                <div class="st-product-card-actions">
                    <el-tag type="primary">Coming soon ...</el-tag>
                </div>
            </div>
        </div>

        <div class="col-md-3 col-lg-4">
            <div class="st-product-card">
                <div class="st-product-card-header">
                    <span class="icon-circle whatsapp">
                        <i class="fab fa-whatsapp fa-1x"/>
                    </span>
                </div>

                <div class="st-product-card-body">
                    <h6>Engage with your customers from <b>whatsapp</b>.</h6>
                </div>

                <div class="st-product-card-body-x">
                    <p>Embed a emalify web chat in your website so your website visitors can interact with you in realtime.</p>
                </div>

                <div class="st-product-card-actions">
                    <el-tag type="primary">Coming soon ...</el-tag>
                </div>
            </div>
        </div>

        <div class="col-md-3 col-lg-4">
            <div class="st-product-card">
                <div class="st-product-card-header">
                    <span class="icon-circle twitter">
                        <i class="fab fa-twitter fa-1x"/>
                    </span>
                </div>

                <div class="st-product-card-body">
                    <h6>Engage with your customers who reach you via <b>twitter</b>.</h6>
                </div>

                <div class="st-product-card-body-x">
                    <p>Channel all communications via your twitter handle in a single place.</p>
                </div>

                <div class="st-product-card-actions">
                    <el-tag type="primary">Coming soon ...</el-tag>
                </div>
            </div>
        </div>

        <div class="col-md-3 col-lg-4">
            <div class="st-product-card">
                <div class="st-product-card-header">
                    <span
                        class="icon-circle facebook">
                        <i class="fab fa-facebook fa-1x"/>
                    </span>
                </div>

                <div class="st-product-card-body">
                    <h6>Engage with your customers who reach you via <b>facebook</b>.</h6>
                </div>

                <div class="st-product-card-body-x">
                    <p>Channel all communications via your twitter handle in a single place.</p>
                </div>

                <div class="st-product-card-actions">
                    <el-tag type="primary">Coming soon ...</el-tag>
                </div>
            </div>
        </div>

        <div class="col-md-3 col-lg-4">
            <div class="st-product-card">
                <div class="st-product-card-header">
                    <span
                        class="icon-circle email"
                        style="">
                            <i class="el-icon-message"/>
                    </span>
                </div>

                <div class="st-product-card-body">
                    <h6>Engage with your customers who reach to you via <b>email</b>.</h6>
                </div>

                <div class="st-product-card-body-x">
                    <p>Manage conversations coming through your email address from emalify chat solution</p>
                </div>

                <div class="st-product-card-actions">
                    <el-tag type="primary">Coming soon ...</el-tag>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import "src/sass/custom/onboarding";
</style>
